import { Button, Datepicker, Modal } from "flowbite-react";
import React, { ChangeEvent, useEffect } from "react";
import { useReducerAsState } from "../hooks/useReducerAsState";

interface DateTimePickerProps {
    isOpen: boolean;
    date: string;
    time: string;
    title?: string;
    onClose: () => void;
    onSelectedDateTime: (dateTime: string) => void;
}

interface DateTimePickerState {
    show: boolean;
    date: string;
    time: string;
}

const DateTimePicker = (props: DateTimePickerProps) => {

    const [state, setState] = useReducerAsState<DateTimePickerState>({
        show: false,
        date: "",
        time: "",
    });

    useEffect(() => {
        setState({
            show: props.isOpen,
            date: props.date.length > 0 ? props.date : new Date().toISOString().split('T')[0],
            time: props.time !== undefined ? props.time : "00:00",
        })
        // eslint-disable-next-line
    },[props])

    const onClose = () => {
        setState({ show: false });
        props.onClose();
    }

    const onContinue = () => {
        if(state.date.length === 0 || state.time.length === 0) return;
        const dateTime = `${state.date}T${state.time}`
        props.onSelectedDateTime(dateTime)
        onClose()
    }

    const onSelectDate = (date: Date) => {
        setState({ date: date.toISOString().split('T')[0] })
    }

    const isToday = (someDate: Date) => {
        const today = new Date()
        return someDate.getDate() === today.getDate() &&
          someDate.getMonth() === today.getMonth() &&
          someDate.getFullYear() === today.getFullYear()
      }

    const onTimeChange = (time: ChangeEvent<HTMLInputElement>) => {
        setState({ time: time.target.value })
    }

    const renderContent = () => {
        if(state.date.length === 0 || state.time.length === 0) return <></>;

        const propsDate = state.date.split('-');
        const formattDate = new Date(parseInt(propsDate[0]), parseInt(propsDate[1]) - 1, parseInt(propsDate[2]));
        const today = new Date();
        const hours = today.getHours();
        const minutes = today.getMinutes();
        const selectedDateIsToday = isToday(formattDate)
        const minTime = selectedDateIsToday ? `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}` : "00:00"

       
        return <div className="flex flex-col items-center pb-4">
            <Datepicker 
                inline
                language="es-ES" 
                labelTodayButton="Hoy"
                minDate={new Date()}
                defaultDate={formattDate}
                labelClearButton="Limpiar"
                onSelectedDateChanged={onSelectDate}
            />
            <br />
            {selectedDateIsToday ? <span className="">Hora mínima elegible {minTime}{hours >= 12 ? 'PM' : 'AM'}</span> : <></>}
            <br/>
            <label htmlFor="time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Elija una hora</label>
            <div className="relative">
                <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                        <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z" clip-rule="evenodd"/>
                    </svg>
                </div>
                <input type="time" id="time" className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" min={minTime} value={state.time} onChange={onTimeChange} />
            </div>
            </div>
    }

    return <Modal size="md" show={state.show} onClose={onClose}>
          <Modal.Header>{props.title ?? "Seleccione una fecha"}</Modal.Header>
          <Modal.Body className="p-0">
              {renderContent()}
          </Modal.Body>
          <Modal.Footer className="flex flex-row justify-between">
              <Button color="gray" onClick={onClose}>Cerrar</Button>
              <Button color="blue" onClick={onContinue}>Continuar</Button>
          </Modal.Footer>
      </Modal>
}

export default DateTimePicker;